export const maskEmail = (email) => {
  if (!email) return '';
  try {
    const str = String(email).trim();
    const parts = str.split('@');
    if (parts.length < 2) return str;
    const local = parts[0];
    const domain = parts.slice(1).join('@');
    if (local.length <= 2) return `${local[0]}****@${domain}`;
    if (local.length <= 4) return `${local[0]}****${local.slice(-1)}@${domain}`;
    return `${local.slice(0, 2)}****${local.slice(-1)}@${domain}`;
  } catch (e) {
    return email || '';
  }
};

export const maskPhone = (phone) => {
  if (!phone) return '';
  try {
    const raw = String(phone).trim();
    const digits = raw.replace(/\D/g, '');
    const len = digits.length;
    if (len <= 4) return raw;
    if (len === 10) {
      return `${digits.slice(0, 3)}****${digits.slice(7)}`;
    }
    if (len === 12 && digits.startsWith('91')) {
      const core = digits.slice(2);
      return `+91 ${core.slice(0, 3)}****${core.slice(7)}`;
    }
    const start = Math.floor((len - 4) / 2);
    return digits.slice(0, start) + '****' + digits.slice(start + 4);
  } catch (e) {
    return phone || '';
  }
};

export const maskDOB = (dob) => {
  if (!dob) return '';
  const raw = String(dob).trim();
  const isoDate = raw.match(/^(\d{4})([-/.])(\d{1,2})\2(\d{1,2})(.*)$/);
  if (isoDate) {
    return `${isoDate[4]}${isoDate[2]}**${isoDate[2]}****${isoDate[5]}`;
  }

  const dayFirstNumericDate = raw.match(/^(\d{1,2})([-/.])(\d{1,2})\2(\d{2,4})(.*)$/);
  if (dayFirstNumericDate) {
    return `${dayFirstNumericDate[1]}${dayFirstNumericDate[2]}**${dayFirstNumericDate[2]}****${dayFirstNumericDate[5]}`;
  }

  const dayFirstTextDate = raw.match(/^(\d{1,2})([\s,./-]+)([A-Za-z]+)([\s,./-]+)(\d{2,4})(.*)$/);
  if (dayFirstTextDate) {
    return `${dayFirstTextDate[1]}${dayFirstTextDate[2]}${'*'.repeat(dayFirstTextDate[3].length)}${dayFirstTextDate[4]}${'*'.repeat(dayFirstTextDate[5].length)}${dayFirstTextDate[6]}`;
  }

  return raw.replace(/[A-Za-z0-9]/g, '*');
};

export default { maskEmail, maskPhone, maskDOB };
